import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';

import { NgxSpinnerService } from 'ngx-spinner';
import { SpinnerType } from 'app/base/enums';
import {
  CustomToastrService,
  ToastrMessageType,
  ToastrPosition,
} from 'app/base/services/custom-toast-service';
import { UnifiedAuthService } from 'app/services/yoklama/auth.service';
import { environment } from 'environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: UnifiedAuthService,
    private jwtHelper: JwtHelperService,
    private router: Router,
    private toastrService: CustomToastrService,
    private spinner: NgxSpinnerService,
  ) {
    const { _isAuthenticated } = this.authService.identityCheck();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.spinner.show(SpinnerType.BallAtom);
    //const token: string = localStorage.getItem("accessToken");

    ////const decodeToken = this.jwtHelper.decodeToken(token);
    ////const expirationDate: Date = this.jwtHelper.getTokenExpirationDate(token);
    //let expired: boolean;
    //try {
    //  expired = this.jwtHelper.isTokenExpired(token);
    //} catch {
    //  expired = true;
    //}

    if (!this.authService.identityCheck()._isAuthenticated) {
      if (state.url === '/welcome') {

        state.url = 'welcome';
      }
      this.router.navigate(['login'], {
        queryParams: { returnUrl: state.url, version: environment.version },
      });
      /* this.toastrService.message(
        'Oturum açmanız gerekiyor!',
        'Yetkisiz Erişim!',
        {
          messageType: ToastrMessageType.Warning,
          position: ToastrPosition.TopRight,
        },
      ); */
    }

    this.spinner.hide(SpinnerType.BallAtom);

    return true;
  }
}
